export default __webpack_public_path__ + "static/media/third.506364d9.svg";